import PlaceholderJewelry from '../src/PlaceholderJewelry';
export default PlaceholderJewelry;
